<div class="row">
    <div class="col-md-5">
        <div class="card card-custom card-stretch gutter-b">
            <!-- Header -->
            <div class="card-header border-0">
                <h3 class="card-title font-weight-bolder text-dark">{{sectionLabel}}</h3>
            </div>
            <!-- Body -->
            <div class="card-body">
                <div class="tasks" *ngIf="tasksAvailable('other'); else noTasksFound">
                    <div class="single-task-list" *ngFor="let task of otherTasks; let i = index">
                        <div class="d-flex align-items-center mb-10">
                            <span class="bullet bullet-bar align-self-stretch mr-2"
                                  style="background-color: {{task.labelColour}}"></span>
                            <div class="d-flex flex-column font-weight-bold">
                                <a class="card-label font-weight-bolder text-dark cursor-pointer"
                                   (click)="setCurrentTask(task.id, 'other')">
                                    {{task.messageTitle}}
                                </a>
                                <span class="text-muted">{{task.deadline | date:"dd/MM/yyyy"}}</span>
                                <span class="text-muted">{{task.status}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noTasksFound>
                    <p>Momentan nu sunt discutii disponibile.</p>
                </ng-template>

                <div class="archived-tasks">
                    <div class="preview-toggle">
                        <div>
                            <button type="button"
                                    class="btn btn-primary"
                                    (click)="isCollapsed = !isCollapsed"
                                    [attr.aria-expanded]="!isCollapsed"
                                    aria-controls="collapseExample">
                                Arhiva
                            </button>
                        </div>
                        <div id="collapseExample" [ngbCollapse]="isCollapsed">
                            <div class="card">
                                <div class="card-body" *ngIf="tasksAvailable('done'); else noArchivedTasks">
                                    <div class="single-task-list" *ngFor="let task of doneTasks; let i = index">
                                        <div class="d-flex align-items-center mb-10">
                            <span class="bullet bullet-bar align-self-stretch mr-2" style="background-color: {{task.labelColour}}" ></span>
                                            <div class="d-flex flex-column font-weight-bold">
                                                <a class="text-dark-75 text-hover-primary mb-1 font-size-lg cursor-pointer"
                                                   (click)="setCurrentTask(task.id, 'done')">
                                                    {{task.messageTitle}}
                                                </a>
                                                <span class="text-muted">{{task.deadline | date:"dd/MM/yyyy"}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #noArchivedTasks>
                                    <p>Momentan nu este nimic disponibile.</p>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <!-- Single task -->
    <div class="col-md-7 task-preview-container">
        <div class="card card-custom card-stretch gutter-b">
            <div class="spinner-container" *ngIf="showLoader">
                <mat-spinner></mat-spinner>
            </div>

            <div *ngIf="tasksAvailable('other') || tasksAvailable('done')">
                <!-- Header -->
                <div class="card-body">
                    <h2 class="card-title font-weight-bolder text-dark mb-0">{{previewTask.messageTitle}}</h2>
                    <div class="card-header">
                        <div class="change-status-container">
                            <select [(ngModel)]="previewTask.status" name="taskStatus" class="form-control"
                                    (change)="onChangeStatus($event.target, previewTask)">
                                <option value="Nou">Nou</option>
                                <option value="In-lucru">In lucru</option>
                                <option value="Pauza">Pauza</option>
                                <option value="Done">Rezolvat</option>
                            </select>
                        </div>

                        <div class="color-box ng-star-inserted label-container"
                             style="background-color: {{previewTask.labelColour}}">
                            <span *ngIf="this.type === 'tasks'">{{previewTask.labelTask}}</span>
                            <span *ngIf="this.type === 'pdp'">{{previewTask.labelDevelopmentPlan}}</span>
                        </div>
                    </div>


                    <div class="task-files mb-3">
                        <span class="card-label font-weight-bolder text-dark">Fisiere: </span>
                        <div *ngFor="let file of previewTask.attachments; let i = index" class="d-flex align-items-center pb-3">
                            <a class="pr-2" target="_blank" href="{{file.link}}">{{file.name}}</a>
                            <!-- Delete button -->
                            <button (click)="deleteFile(i)" class="delete-button d-flex align-items-center justify-content-center"><span class="fas fa-times"></span></button>
                        </div>
                        <input type="file" (change)="uploadTaskAttachment($event)">
                    </div>
                    <span class="mt-5 card-label font-weight-bolder text-dark">Detalii:</span>
                    <p>{{previewTask.messageDetail}}</p>
                    <span class="card-label font-weight-bolder text-dark">Deadline:</span>
                    <p>{{previewTask.deadline | timeBetween}} ({{previewTask.deadline | date:"dd-MM-yyyy"}})</p>


                    <div *ngIf="this.type === 'tasks'">
                        <div class="task-comment" *ngFor="let comment of previewTask.taskMessages">
                            <span class="card-label font-weight-bolder text-dark" *ngIf="this.previewTask.receiverUserId === comment.userId">{{this.receiverName}}</span>
                            <span class="card-label font-weight-bolder text-dark" *ngIf="this.previewTask.senderUserId === comment.userId">{{this.senderName}}</span>
                            <span class="text-muted">{{comment.messageDate | timeBetween}}<mat-icon>watch_later</mat-icon></span>
                            <p>{{comment.message}}</p>
                        </div>
                    </div>

                    <div *ngIf="this.type === 'pdp'">
                        <div class="task-comment" *ngFor="let comment of previewTask.developmentPlanMessages">
                            <span class="card-label font-weight-bolder text-dark" *ngIf="this.previewTask.receiverUserId === comment.userId">{{this.receiverName}}</span>
                            <span class="card-label font-weight-bolder text-dark" *ngIf="this.previewTask.senderUserId === comment.userId">{{this.senderName}}</span>
                            <span class="text-muted">{{comment.messageDate | timeBetween}}<mat-icon>watch_later</mat-icon></span>
                            <p>{{comment.message}}</p>
                        </div>
                    </div>

                    <div class="task-commets-container" *ngIf="previewTask.status !== 'Done'; else taskClosed">
                        <form (ngSubmit)="sendMessage(messageForm)" #messageForm="ngForm">
                            <span class="card-label font-weight-bolder text-dark">Lasa un comentariu</span>
                                <textarea class="form-control" name="message" ngModel #message="ngModel" maxlength="256"  placeholder="Comentariu" required></textarea>
                                <div class="error-msg" *ngIf="!message.valid && (message.touched || messageForm.submitted)">Acest
                                    camp este obligatoriu!
                                </div>
                            <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                            <app-form-message [success]="formResponse" [customErrorMessage]="formResponse === false ? 'Nu puteți șterge taskul daca nu vă aparține sau sunteți admin' : ''" *ngIf="deleteAttachment"></app-form-message>
                            <button type="submit"
                                    class="send-comment round-button form-control">
                                Trimite
                            </button>
                        </form>
                    </div>
                    <ng-template #taskClosed>
                        <p>Aceasta discutie este marcata ca fiind completa, nu poti lasa comentarii.</p>
                    </ng-template>

                </div>
            </div>
        </div>
    </div>
</div>
